import { openSubcontractorCellModal } from '../../../State/subcontractorCellModal'

export default (period, subcontractor, jobs, plannerCell) => (dispatch) => {

  dispatch(openSubcontractorCellModal({ period, subcontractor, jobs, plannerCell }))

}
